import { actionTypes } from './bookmakersButtonsPopovers.actions';

const initialState = {
    activePopoverType: null,
    activePopoverFeed: null,
    show: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLOSE_CURRENT_ACTIVE_POPOVER:
            return {
                ...state,
                show: false,

            }
        case actionTypes.SET_CURRENT_ACTIVE_POPOVER:
            return {
                activePopoverType: action.activePopoverType,
                activePopoverFeed: action.activePopoverFeed,
                show: true,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /src/js/common/bookmakersListPopover/bookmakersButtonsPopovers.reducer.js